import { fetchArticleList } from "@Services/kindsum";
import { IArticleList } from "@Types/kindsum";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { formatThousend, formatVideoDuration } from "../../utils/helper";
import { LikeIcon } from "@t8891/icon";

type ItemProps = {
  item: IArticleList["items"][0];
};
const Item: React.FC<ItemProps> = ({ item }) => {
  const { link, slug, startTime, thumb, title, type, views, likes, playTime } = item;

  return (
    <div
      id={"summaryContentItem"}
      className={`h-236 cursor-pointer border-1 border-[#E8E8E8] border-solid rounded-4 ${
        type === 3 ? "w-248" : "w-210"
      }`}
      onClick={() => {
        window.open(link, "_blank");
      }}
    >
      <div
        className={`relative mb-10 ${
          [3, 11].includes(type) ? "summaryContentItem-Movie" : "summaryContentItem-Article"
        }`}
      >
        {type === 11 && playTime !== 0 && (
          <div className='absolute right-0 bottom-0 bg-[#0000005c] text-white text-12 rounded-[4px 0 0 0] px-4 py-2'>
            {formatVideoDuration(playTime)}
          </div>
        )}
        <img
          className={`${type === 11 ? "object-contain bg-[#000]" : "object-cover"}  h-140 rounded-tl-4 rounded-tr-4 ${
            type === 3 ? "w-246" : "w-208"
          }`}
          src={thumb}
          alt=''
        />
        {[3, 11].includes(type) && (
          <img
            className='absolute top-0 left-0 right-0 bottom-0 m-auto w-56 h-56'
            src='https://photo.8891.com.tw/2024/08/02/1722568013146851.png'
            alt=''
          />
        )}
      </div>
      <p className='text-14 text-[#333] font-medium whitespace-normal mb-8 px-8 h-38 line-clamp-2'>{title}</p>
      {type === 11 ? (
        <div className='flex justify-between items-center mx-8 mt-18 text-[#999999] text-12'>
          <div>{formatThousend(views)}瀏覽</div>
          <div className='flex gap-4'>
            <LikeIcon size={32} /> {likes}
          </div>
        </div>
      ) : (
        <div className='flex justify-between items-center mx-8 mt-18 text-[#999999] text-12'>
          <div className='w-100'>{startTime.slice(0, 10)}</div>
          <div>{type === 3 ? `${views !== 0 ? `播放${formatThousend(views)}次` : ""}` : slug}</div>
        </div>
      )}
    </div>
  );
};

const ArticleList: React.FC<any> = ({ name, setParams, kindId }) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [left, setLeft] = useState<boolean>(true);
  const [right, setRight] = useState<boolean>(true);

  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
  }, []);

  const checkWidth = useCallback(() => {
    if (targetRef.current) {
      const { scrollWidth, clientWidth } = targetRef.current;
      scrollWidth > clientWidth ? setRight(false) : setRight(true);
    }
  }, []);

  const onScroll = useCallback((e) => {
    const element = e.currentTarget;
    const scrollLeft = element.scrollLeft;
    const scrollWidth = element.scrollWidth;
    const clientWidth = element.clientWidth;

    // 计算右边界
    const scrollRight = scrollWidth - clientWidth;

    // 判断是否滑动到最右边
    setRight(scrollLeft >= scrollRight);
    setLeft(scrollLeft === 0);
  }, []);

  const initData: IArticleList = {
    items: [],
    paging: "",
    total: 0,
  };
  const { data = initData } = useQuery<IArticleList>([`fetchArticleList`, name], async () => {
    const res = await fetchArticleList({
      kindIds: kindId,
      contentType2Group: name,
      from: "pc综述頁",
      limit: 20,
    });
    if (res?.status === 12000) {
      let articleId: any = [];
      if (res.data.items.length > 0) {
        res.data.items.forEach((item) => {
          articleId.push(`${item.type}_${item.id}`);
        });
      }

      setParams({
        articleId: articleId,
      });
      return res.data;
    }
    return initData;
  });

  useEffect(() => {
    if (data.items.length === 0) return;
    if (!targetRef.current) return;
    targetRef.current!.addEventListener("scroll", onScroll);
    window.addEventListener("resize", checkWidth);

    checkWidth();
    targetRef.current!.scrollTo(0, 0);
    return () => {
      if (!targetRef.current) return;
      targetRef.current!.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", checkWidth);
    };
  }, [data]);

  return (
    <div id={"ArticleList"} className='relative mt-16 h-234'>
      {!left && (
        <i
          className='w-22 h-60 block absolute left-0 top-40 z-[2]'
          style={{
            backgroundImage: `url(https://photo.8891.com.tw/2024/06/18/1718703170048109.png)`,
            backgroundSize: "100%",
          }}
          onClick={() => scrollTo(-665)}
        />
      )}
      {!right && (
        <i
          className='w-22 h-60 block absolute right-0 top-40 z-[2]'
          style={{
            backgroundImage: `url(https://photo.8891.com.tw/2024/06/18/1718703170003603.png)`,
            backgroundSize: "100%",
          }}
          onClick={() => scrollTo(665)}
        />
      )}
      <div
        className='flex gap-20 scroll-smooth overflow-auto scrollbar-hide border-box'
        ref={targetRef}
        style={{ scrollbarWidth: "none", scrollbarColor: "transparent transparent" }}
      >
        {data?.items.length > 0 && data.items.map((item, index: number) => <Item key={index} item={item} />)}
      </div>
    </div>
  );
};

export default ArticleList;
